module.exports = __webpack_public_path__ + "img/img_20.53d30f91.png";